import { BigNumber } from "bignumber.js";
import { fAmount, fNumber } from "kz-ui-sdk";

/**
 * Add more mockup digits for small amount which less than 1000
 *
 * @example
 * Input: 0.10 -> 0-.-1-0
 * Input: 1,00 -> 1-,-0-0
 * Input: 10.00 -> 1-0.0-0
 * Input: 100.00 -> 100-.00
 * Input: 1,000.00 -> 1,000.00
 */
const toSpinningDigits = (input: number, abbreviate = true) => {
  // if amount >= 100,000 then round and remove decimal
  let formattedInput = "";
  const amountBn = new BigNumber(input);
  if (amountBn.gte(100_000)) {
    formattedInput = fNumber(amountBn.dp(0, BigNumber.ROUND_DOWN), {
      abbreviate,
    }).replace(" ", "");
  } else {
    formattedInput = fAmount(amountBn, {
      abbreviate,
    });
  }
  const inputLength = formattedInput.length;
  if (inputLength === 3) {
    return `${formattedInput[0]}-${formattedInput[1]}-${formattedInput[2]}`;
  } else if (inputLength === 4) {
    return `${formattedInput[0]}-${formattedInput[1]}-${formattedInput[2]}-${formattedInput[3]}`;
  } else if (inputLength === 5) {
    return `${formattedInput[0]}-${formattedInput[1]}${formattedInput[2]}${formattedInput[3]}-${formattedInput[4]}`;
  } else if (inputLength === 6) {
    return `${formattedInput[0]}${formattedInput[1]}${formattedInput[2]}-${formattedInput[3]}${formattedInput[4]}${formattedInput[5]}`;
  }
  return formattedInput;
};

export default toSpinningDigits;
